import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

interface Props {
    title: React.ReactNode;
    main: React.ReactNode;
    aside: React.ReactNode;
    media: React.ReactNode;
    variations?: string[];
}

export default function TextFullWidthMediaLayout({ title, main, aside, media }: Props) {
    return (
        <LayoutContainer>
            <TextContainer>
                <ContentTitle>{title}</ContentTitle>
                <ContentMain>{main}</ContentMain>
                <ContentAside>{aside}</ContentAside>
            </TextContainer>
            <ContentMedia>{media}</ContentMedia>
        </LayoutContainer>
    );
}

const LayoutContainer = styled.div`
    display: grid;
    grid-template-rows: auto;
    grid-template-areas:
        'text-container'
        'media-container';
`;

const TextContainer = styled.div`
    display: grid;
    grid-area: text-container;
    grid-template-rows: auto;

    padding-bottom: ${spaces['2bu']};

    ${mediaQuery.minimum('normal')} {
        grid-template-columns: 50% 50%;
        grid-template-areas:
            'title-container title-container'
            'main-container aside-container';
    }

    ${mediaQuery.between('small', 'medium')} {
        grid-template-columns: 1fr;
        grid-template-areas:
            'title-container'
            'main-container'
            'aside-container';
    }
`;

const ContentMain = styled.div`
    grid-area: main-container;
    padding: ${spaces['4bu']};

    ${mediaQuery.between('small', 'medium')} {
        padding: 0;
    }
`;

const ContentAside = styled.div`
    grid-area: aside-container;

    ${mediaQuery.only('large')} {
        padding-left: ${spaces['8bu']};
    }
    ${mediaQuery.only('normal')} {
        padding-left: ${spaces['4bu']};
    }
`;

const ContentTitle = styled.div`
    grid-area: title-container;
`;

const ContentMedia = styled.div`
    grid-area: media-container;
`;
